import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import { Call } from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    data: null,
};

export const CurpValidate = createSlice({
    name: "CurpValidate",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        clearData: (state) => {
            state.data = initialState.data;
        },
    },
});

export const { setData, clearData } = CurpValidate.actions;

export default CurpValidate.reducer;

//* Actions
export const startValidateCURP = (
    curp,
    showValidationSwal = true,
    countriesList = [],
    statesList = []
) => {
    return async (dispatch) => {
        //* INICIO: Validaciones antes de hacer dispatch
        if (showValidationSwal) {
            let swalMessage = null;

            if (!curp) {
                swalMessage = "Ingrese una CURP";
            } else if (curp?.length !== 18) {
                swalMessage = "La CURP debe contener dieciocho caracteres";
            }

            if (swalMessage) {
                Swal.fire({
                    title: "CURP incorrecta",
                    text: swalMessage,
                    icon: "warning",
                });
                return;
            }
        }
        //* FIN: Validaciones antes de hacer dispatch

        dispatch(startUILoading());

        const resp = await Call(
            `services/curp-validate/validate-curp`,
            "POST",
            {
                curp,
            }
        );

        if (resp.success) {
            dispatch(setData(resp.success));
        } else {
            dispatch(setData(resp.error));
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startCreate = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `services/curp-validate/create`,
            "POST",
            values
        );

        if (resp.success) {
            dispatch(setData(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startGet = (curp) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("curp", curp);

        const resp = await Call(
            `services/curp-validate/get`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setData(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
